module.exports = __webpack_public_path__ + "img/star-regular-dark.1fc66d90.svg";